import AddChartIcon from '@mui/icons-material/Addchart';
import { useWidget } from '../widget.hook';
import { FC, useCallback } from 'react';
import { TradingMode } from '@shared/types';
import { SxProps } from '@mui/material';
import { AppIconButton } from '@client/foundation/design-system/components';

type OpenTradingFormButtonProps = {
  mode: TradingMode;
  sx?: SxProps;
  onOpen?: () => void | Promise<void>;
};

export const OpenTradingFormButton: FC<OpenTradingFormButtonProps> = ({
  mode,
  sx,
  onOpen
}) => {
  const { openWidget } = useWidget();
  const baseSx: SxProps = { alignSelf: 'flex-start', width: 'fit-content' };
  const resolvedSx: SxProps = sx ? { ...baseSx, ...sx } : baseSx;

  const handleOpenTradingForm = useCallback(() => {
    if (onOpen) {
      void onOpen();
      return;
    }
    openWidget({ type: 'TradingForm', mode, initSource: 'NEW_FORM' });
  }, [onOpen, openWidget, mode]);

  return (
    <AppIconButton
      title="Add symbol"
      tone="primary"
      onClick={handleOpenTradingForm}
      sx={resolvedSx}
    >
      <AddChartIcon />
    </AppIconButton>
  );
};
